/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'ru',
  Pagination: {
    items_per_page: '/ стр.',
    jump_to: 'Перейти',
    jump_to_confirm: 'подтвердить',
    page: '',
    prev_page: 'Назад',
    next_page: 'Вперед',
    prev_5: 'Предыдущие 5',
    next_5: 'Следующие 5',
    prev_3: 'Предыдущие 3',
    next_3: 'Следующие 3'
  },
  DatePicker: {
    lang: {
      placeholder: 'Выберите дату',
      rangePlaceholder: ['Начальная дата', 'Конечная дата'],
      locale: 'ru_RU',
      today: 'Сегодня',
      now: 'Сейчас',
      backToToday: 'Текущая дата',
      ok: 'Ok',
      clear: 'Очистить',
      month: 'Месяц',
      year: 'Год',
      timeSelect: 'Выбрать время',
      dateSelect: 'Выбрать дату',
      monthSelect: 'Выбрать месяц',
      yearSelect: 'Выбрать год',
      decadeSelect: 'Выбрать десятилетие',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Предыдущий месяц (PageUp)',
      nextMonth: 'Следующий месяц (PageDown)',
      previousYear: 'Предыдущий год (Control + left)',
      nextYear: 'Следующий год (Control + right)',
      previousDecade: 'Предыдущее десятилетие',
      nextDecade: 'Следущее десятилетие',
      previousCentury: 'Предыдущий век',
      nextCentury: 'Следующий век'
    },
    timePickerLocale: {
      placeholder: 'Выберите время'
    }
  },
  TimePicker: {
    placeholder: 'Выберите время'
  },
  Calendar: {
    lang: {
      placeholder: 'Выберите дату',
      rangePlaceholder: ['Начальная дата', 'Конечная дата'],
      locale: 'ru_RU',
      today: 'Сегодня',
      now: 'Сейчас',
      backToToday: 'Текущая дата',
      ok: 'Ok',
      clear: 'Очистить',
      month: 'Месяц',
      year: 'Год',
      timeSelect: 'Выбрать время',
      dateSelect: 'Выбрать дату',
      monthSelect: 'Выбрать месяц',
      yearSelect: 'Выбрать год',
      decadeSelect: 'Выбрать десятилетие',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Предыдущий месяц (PageUp)',
      nextMonth: 'Следующий месяц (PageDown)',
      previousYear: 'Предыдущий год (Control + left)',
      nextYear: 'Следующий год (Control + right)',
      previousDecade: 'Предыдущее десятилетие',
      nextDecade: 'Следущее десятилетие',
      previousCentury: 'Предыдущий век',
      nextCentury: 'Следующий век'
    },
    timePickerLocale: {
      placeholder: 'Выберите время'
    }
  },
  global: {
    placeholder: 'Пожалуйста выберите'
  },
  Table: {
    filterTitle: 'Фильтр',
    filterConfirm: 'OK',
    filterReset: 'Сбросить',
    selectAll: 'Выбрать всё',
    selectInvert: 'Инвертировать выбор',
    sortTitle: 'Сортировка',
    expand: 'Развернуть строку',
    collapse: 'Свернуть строку',
    triggerDesc: 'Нажмите для сортировки по убыванию',
    triggerAsc: 'Нажмите для сортировки по возрастанию',
    cancelSort: 'Нажмите, чтобы отменить сортировку'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Отмена',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Отмена'
  },
  Transfer: {
    searchPlaceholder: 'Поиск',
    itemUnit: 'элем.',
    itemsUnit: 'элем.'
  },
  Upload: {
    uploading: 'Загрузка...',
    removeFile: 'Удалить файл',
    uploadError: 'При загрузке произошла ошибка',
    previewFile: 'Предпросмотр файла',
    downloadFile: 'Загрузить файл'
  },
  Empty: {
    description: 'Нет данных'
  },
  Icon: {
    icon: 'иконка'
  },
  Text: {
    edit: 'редактировать',
    copy: 'копировать',
    copied: 'скопировано',
    expand: 'раскрыть'
  },
  PageHeader: {
    back: 'назад'
  }
};
